.active {
  color: var(--tuna-palette-error-main);
}
